import { render } from "./OARegistrar.vue?vue&type=template&id=16d8bbbf&scoped=true"
import script from "./OARegistrar.vue?vue&type=script&lang=js"
export * from "./OARegistrar.vue?vue&type=script&lang=js"

import "./OARegistrar.vue?vue&type=style&index=0&id=16d8bbbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d8bbbf"]])

export default __exports__